import axios from 'axios';
import localStorageService from './localStorageService';

const apiHost = process.env.REACT_APP_APIURL;

const axiosInstance = axios.create({ baseURL: apiHost });

axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = localStorageService.getAccessToken();
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // clear token
      localStorageService.clearAccessToken();
      // Utiliser navigate au lieu de window.location.href
      // Il faudra émettre un événement ou callback global
      window.dispatchEvent(new Event('logout')); 
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
